import { Phone, Mail, MapPin, ExternalLink } from "lucide-react";
import {
  PHONE_DISPLAY,
  PHONE_TEL,
  EMAIL,
  GBP_URL,
  BUSINESS_NAME,
  SERVICE_AREA,
} from "../../lib/business";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-black border-t border-white/10 pt-16 pb-28 sm:pb-16"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <a href="#top" className="inline-flex items-center" aria-label={BUSINESS_NAME}>
              <img
                src="/logo.jpg"
                alt={BUSINESS_NAME}
                data-testid="footer-logo"
                className="h-16 w-auto rounded-md bg-white p-2"
              />
            </a>
            <p className="mt-4 font-body text-sm text-zinc-400 max-w-sm leading-relaxed">
              {BUSINESS_NAME}. Premium mobile carwash &amp; detailing serving{" "}
              {SERVICE_AREA} and surrounds. We come to you.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="font-display text-xs uppercase tracking-[0.3em] text-zinc-500 mb-4">
              Explore
            </div>
            <ul className="space-y-2 font-body text-sm">
              {[
                ["Services", "#services"],
                ["Why Us", "#why"],
                ["Gallery", "#gallery"],
                ["Reviews", "#reviews"],
                ["Contact", "#contact"],
              ].map(([label, href]) => (
                <li key={href}>
                  <a
                    href={href}
                    data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-zinc-400 hover:text-white transition-colors"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="font-display text-xs uppercase tracking-[0.3em] text-zinc-500 mb-4">
              Contact
            </div>
            <ul className="space-y-3 font-body text-sm">
              <li>
                <a
                  href={PHONE_TEL}
                  data-testid="footer-phone"
                  className="inline-flex items-center gap-2 text-white hover:text-[#E10600] transition-colors"
                >
                  <Phone className="w-4 h-4" /> {PHONE_DISPLAY}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${EMAIL}`}
                  data-testid="footer-email"
                  className="inline-flex items-center gap-2 text-zinc-300 hover:text-white transition-colors text-xs sm:text-sm break-words"
                >
                  <Mail className="w-4 h-4 shrink-0" /> {EMAIL}
                </a>
              </li>
              <li>
                <span className="inline-flex items-center gap-2 text-zinc-300">
                  <MapPin className="w-4 h-4" /> {SERVICE_AREA}
                </span>
              </li>
              <li>
                <a
                  href={GBP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-gbp"
                  className="inline-flex items-center gap-2 text-[#E10600] hover:text-[#FF2D1A] transition-colors"
                >
                  Google Business Profile <ExternalLink className="w-4 h-4" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <div className="font-body text-xs text-zinc-500">
            © {year} {BUSINESS_NAME}. All rights reserved.
          </div>
          <div className="font-display text-xs uppercase tracking-[0.3em] text-zinc-600">
            Newcastle · NSW · Australia
          </div>
        </div>
      </div>
    </footer>
  );
}
